import { KPI_CARDS } from './kpiPeople';
import { useT } from '@hana/i18n';
import './screens.i18n';
import { Card } from './HrKpiPerson';
import s from './kpiPerson.module.css';

// Mint-KPI · tab KPI của tôi (code board: tab === 'mine'). Thẻ của DAVID (ghế SALE-MGR) + việc KPI chờ tôi. Không tiền.

const TODO: { chip: string; tone: [string, string]; k: string; sub: string }[] = [
  { chip: 'TUANNT đang giải trình', tone: ['var(--warn-bg)', 'var(--warn)'], k: 'KPE-2610-004', sub: 'xong sẽ chờ bạn xác nhận (trưởng phòng)' },
];

export function HrKpiMine({ onNote }: { onNote: (m: string) => void }) {
  const t = useT();
  const me = KPI_CARDS.find((x) => x.u === 'DAVID') ?? KPI_CARDS[0]!;
  return (
    <div className={s.grid}>
      <div className={s.wide}>
        <Card p={me} mine onNote={onNote} />
        <section className={s.panel} aria-label="Việc KPI chờ tôi">
          <div className={s.hd}><h2>{t('hr.s.kpiMine')}</h2><span>{t('hr.s.bySeat')}</span></div>
          <div className={s.list}>
            {TODO.map((t, i) => (
              <div key={t.k} className={`${s.lrow} ${i ? s.top : ''}`}>
                <span className={s.liChip} style={{ background: t.tone[0], color: t.tone[1] }}>{t.chip}</span>
                <div className={s.lbody}><b>{t.k}</b><span className={s.lsub}>{t.sub}</span></div>
              </div>
            ))}
            <div className={`${s.lrow} ${s.top}`}>
              <div className={s.lbody}><b>{t('hr.s.mgrAdjust')}</b><span className={s.lsub}>{t('hr.s.optionalNote')}</span></div>
              <b>{t('hr.s.zeroOf4')}</b>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
